import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// import { HOST_MODES } from "@/constants";
import { dataSources } from "@/constants/LandingSection";
// import { getRefreshToken } from "@/shared/utils/accessTokenAndRefreshToken";
import useAuthStore from "@/shared/zustand/authStore";
import useToastStore from "@/shared/zustand/toastStore";
// import { useGoogleLogin } from "@react-oauth/google";
import { ArrowRight } from "lucide-react";
import { Button } from "primereact/button";
import { useState } from "react";
import { LandingSectionStepper } from "./LandingSection";
import { loginWithGoogle } from "@/core/api/api";
// import {
//   addUser,
//   listUsers,
//   setUserAccessScopes,
//   updateUserTokens,
// } from "@/core/api/api";
// interface UserProperties {
//   access_token: string;
//   refresh_token: string;
//   scope: string;
//   expires_in: number;
//   id_token: string;
//   token_type: string;
// }
// const StepTwo = ({
//   handleNext,
//   handleBack,
//   activeStep,
// }: {
//   handleNext: () => void;
//   handleBack: () => void;
//   activeStep: number;
// }) => {
const StepTwo = () => {
    const { user, onboardingStep, setOnboardingStep } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const [loading, setLoading] = useState(false);
    // const [selectedSource, setSelectedSource] = useState<string[]>([]);
    const [selectedSource, setSelectedSource] = useState(user?.provider?.scope
        ?.split(/\s+/) // Split by space to handle multiple scopes
        ?.filter((scope) => dataSources.some((source) => source.scope.split(/\s+/).includes(scope))) || []);
    // const [emailUser, setEmailUser] = useState<UserProperties>({
    //   access_token: "",
    //   refresh_token: "",
    //   scope: "",
    //   expires_in: 0,
    //   id_token: "",
    //   token_type: "",
    // });
    const handleSelectedSource = (scope) => {
        setSelectedSource((prev) => prev.includes(scope) ? prev.filter((p) => p !== scope) : [...prev, scope]);
    };
    // const updateAccessScopes = useCallback(async () => {
    //   try {
    //     setLoading(true);
    //     if (!user?.email) {
    //       showToast("error", "Error", "User email is not available");
    //       return;
    //     }
    //     // old code for api call
    //     // const url = `${process.env.VITE_BASE_API_URL}/user/setAccessScopes`;
    //     // const params = new URLSearchParams({
    //     //   email: user?.email || "",
    //     //   scopes: selectedSource.join(","),
    //     // });
    //     // const response = await axios.post(url, params.toString(), {
    //     //   headers: {
    //     //     "Content-Type": "application/x-www-form-urlencoded",
    //     //     Accept: "application/json",
    //     //   },
    //     // });
    //     const { responseData, error } = await setUserAccessScopes(
    //       user.email,
    //       selectedSource
    //     );
    //     if (error) {
    //       showToast("error", "Error", error.errorMessage);
    //       console.error("Error updating access scopes:", error);
    //       return;
    //     }
    //     if (responseData) {
    //       showToast("success", "Success", "Data sources successfully set");
    //       // handleNext();
    //       setOnboardingStep("done");
    //     } else {
    //       console.error("Unexpected response:", responseData);
    //       showToast("error", "Error", responseData || "An error occurred.");
    //     }
    //   } catch (error) {
    //     console.error("Error updating access scopes:", error);
    //     showToast(
    //       "error",
    //       "Error",
    //       "Failed to update data sources. Please try again."
    //     );
    //   } finally {
    //     setLoading(false);
    //   }
    // }, [selectedSource, user, showToast]);
    // const fetchAndUpdateUser = useCallback(async () => {
    //   if (!emailUser.access_token) return;
    //   try {
    //     const userInfo = await axios.get(
    //       `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${emailUser.access_token}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${emailUser.access_token}`,
    //           Accept: "application/json",
    //         },
    //       }
    //     );
    //     const expirationDate = new Date(
    //       Date.now() + emailUser.expires_in * 1000
    //     ).toISOString();
    //     const userData = {
    //       name: userInfo.data.name,
    //       email: userInfo.data.email,
    //       access_token: emailUser.access_token,
    //       refresh_token: emailUser.refresh_token,
    //       persona: [],
    //       access_scopes: [emailUser.scope],
    //       expiry: expirationDate,
    //     };
    //     await updateAccessScopes();
    //     // old code for api call
    //     // const usersResponse = await axios.get(
    //     //   `${process.env.VITE_BASE_API_URL}/user/listUser`
    //     // );
    //     const { responseData, error } = await listUsers();
    //     if (error) {
    //       showToast("error", "Error", error.errorMessage);
    //       console.error("Error while fetching users: ", error);
    //       return;
    //     }
    //     if (!responseData) {
    //       console.error("Unexpected response:", responseData);
    //       showToast("error", "Error", "Failed to fetch users");
    //       return;
    //     }
    //     const existingUser = responseData?.users.find(
    //       (u: any) => u.email === userInfo.data.email
    //     );
    //     if (existingUser) {
    //       // old code for api call
    //       // await axios.put(
    //       //   `${process.env.VITE_BASE_API_URL}/user/${encodeURIComponent(
    //       //     userInfo.data.email
    //       //   )}/update-tokens`,
    //       //   {
    //       //     access_token: emailUser.access_token,
    //       //     refresh_token: emailUser.refresh_token,
    //       //   },
    //       //   {
    //       //     headers: {
    //       //       "Content-Type": "application/json",
    //       //       accept: "application/json",
    //       //     },
    //       //   }
    //       // );
    //       const { responseData, error } = await updateUserTokens(
    //         userInfo.data.email,
    //         emailUser.access_token,
    //         emailUser.refresh_token
    //       );
    //       if (error) {
    //         showToast("error", "Error", error.errorMessage);
    //         console.error("Error while updating user tokens: ", error);
    //         return;
    //       }
    //     } else {
    //       // old code for api call
    //       // await axios.post(
    //       //   `${process.env.VITE_BASE_API_URL}/user/addUser`,
    //       //   userData,
    //       //   {
    //       //     headers: { "Content-Type": "application/json" },
    //       //   }
    //       // );
    //       const { responseData, error } = await addUser(userData);
    //       if (error) {
    //         showToast("error", "Error", error.errorMessage);
    //         console.error("Error while adding user: ", error);
    //         return;
    //       }
    //     }
    //     setUser(
    //       {
    //         name: userInfo.data.name,
    //         email: userInfo.data.email,
    //         picture: userInfo.data.picture,
    //       }
    //       // expirationDate
    //     );
    //     // setCurrentHostMode(HOST_MODES["Project Mode"]);
    //     // handleNext();
    //   } catch (error) {
    //     console.error("Error fetching or updating user:", error);
    //   }
    // }, [emailUser, updateAccessScopes, setUser]);
    // const googleLogin = useGoogleLogin({
    //   scope: selectedSource.join(" "),
    //   flow: "auth-code",
    //   onSuccess: (codeResponse) => {
    //     const grantedScopes = codeResponse.scope?.split(" ") || [];
    //     const allRequestedScopes = selectedSource.flatMap((scope) =>
    //       scope.split(" ")
    //     );
    //     const missingScopes = allRequestedScopes.filter(
    //       (scope) => !grantedScopes.includes(scope)
    //     );
    //     if (missingScopes.length === 0) {
    //       getRefreshToken(codeResponse, setEmailUser);
    //     } else {
    //       showToast(
    //         "error",
    //         "Permission Denied",
    //         `Missing permissions: ${missingScopes.join(", ")}`
    //       );
    //     }
    //   },
    //   onError: (error) => {
    //     console.error("Login Failed:", error);
    //     showToast(
    //       "error",
    //       "Login Failed",
    //       "Unable to connect your data sources. Please try again."
    //     );
    //   },
    // });
    // useEffect(() => {
    //   fetchAndUpdateUser();
    // }, [emailUser, fetchAndUpdateUser]);
    const handleLoginWithGoogle = async () => {
        try {
            const { responseData, error } = await loginWithGoogle(`email profile openid ${selectedSource.join(" ")}`);
            console.log("response in step 2:", responseData);
            if (responseData?.authorizationUrl) {
                window.location.href = responseData?.authorizationUrl;
            }
            else {
                console.error("Authorization URL not found in response", error);
                showToast("error", "Error", "Authorization URL not found in response");
            }
        }
        catch (error) {
            showToast("error", "Error", "Error during Google login, Check console for more details");
            console.error("Error during Google login:", error);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-col gap-y-6 h-lg:gap-y-8 px-6 h-lg:px-8 pt-6 h-lg:pt-8 overflow-y-auto", children: [_jsxs("div", { className: "flex flex-col gap-y-3", children: [_jsx("h2", { className: "text-3xl h-lg:text-4xl bg-gradient-to-br from-[#2546F0] to-[#5928ED] bg-clip-text text-transparent font-heading font-semibold", children: "Awesome! Let\u2019s Unlock Your Workspace Potential" }), _jsx("p", { className: "text-sm text-[#667085] font-content", children: "Connecting your data sources opens a world of possibilities. Access files seamlessly, get smarter AI insights, and power your creative process with ease." })] }), _jsx("span", { className: "text-base 2xl:text-lg text-[#1F2937] font-medium font-content", children: "#Make the connection" }), _jsxs("div", { className: "w-full p-6 h-lg:p-8 rounded-[8px] border border-[#e0e0e0] flex flex-col gap-y-5", children: [_jsxs("div", { className: "flex flex-col gap-y-4", children: [_jsxs("p", { className: "font-medium text-base", children: ["Step 2: Let\u2019s connect the dots ", _jsx("span", { className: "text-xs", children: "Powered By Agentspace" })] }), _jsx(LandingSectionStepper, { activeStep: onboardingStep }), _jsx("h3", { className: "text-lg font-medium text-[#222222] mt-4", children: "Sync your data sources to provide context-aware insights and a personalized workspace experience." }), _jsx("p", { className: "text-sm lg:text-base text-[#8C8C8C] font-normal", children: "It is recommended to select all data sources that you currently use." })] }), _jsx("div", { className: "grid grid-cols-4 gap-6", children: dataSources?.map((source, key) => (_jsxs("div", { onClick: () => handleSelectedSource(source.scope), className: `${selectedSource.includes(source.scope)
                                        ? "border-[#2546F0] bg-custom-bg-gradient cursor-default"
                                        : "border-transparent cursor-pointer"} text-[#374151] border-[0.5px] flex flex-col justify-center items-center gap-y-5 p-5 rounded-[8px]`, children: [_jsx(source.icon, {}), _jsxs("span", { className: "text-sm text-center", children: [source.label, " ", _jsx("br", {}), " ", _jsx("span", { className: "text-xs", children: source.subtitle })] })] }, key))) })] })] }), _jsxs("div", { className: "w-full flex justify-between items-center px-6 h-lg:px-8 pt-6 pb-6 h-lg:pb-8 border-t border-[#E7E5EB]", children: [_jsxs(Button, { loading: loading, className: "px-4 py-2 rounded-[6px] border border-[#d1d5db] text-xl bg-gradient-to-br from-[#2546F0] to-[#5928ED] bg-clip-text text-transparent flex flex-row-reverse items-center", 
                        // onClick={handleBack}
                        onClick: () => setOnboardingStep("personas"), children: [_jsx("span", { className: "mr-2", children: "Back" }), _jsx("div", { className: "rotate-180 mr-3", children: _jsx(ArrowRight, { color: "#2546F0" }) })] }), _jsxs(Button, { disabled: selectedSource.length < 1, loading: loading, className: "rounded-[6px] px-4 py-2 text-xl text-white flex items-center gap-x-2 transition-all duration-300 bg-gradient-to-r from-[#2546F0] to-[#5928ED] hover:from-[#0039cc] hover:to-[#0039cc]", onClick: handleLoginWithGoogle, children: [_jsx("span", { className: "ml-2", children: "Next" }), _jsx("div", { className: "ml-3", children: _jsx(ArrowRight, {}) })] })] })] }));
};
export default StepTwo;
